// extracted by mini-css-extract-plugin
export default {"root":"ItemizedPaneContent-module__root___1g6sO","closeButtonWrapper":"ItemizedPaneContent-module__closeButtonWrapper___3IWmE"};